if (!Array.prototype.forEach) {
  Array.prototype.forEach = function (fn, ctx) {
    if (this === void 0 || this === null || typeof fn !== "function") {
      throw new TypeError();
    }

    var t = this;
    var len = t.length;

    for (var i = 0; i < len; i++) {
      if (i in t) {
        fn.call(ctx, t[i], i, t);
      }
    }
  };
}

export default {};